import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { FlexColumn, FlexRow, Gap } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from './messages';
import styles from './promotional-price.module.less';
import FormattedCurrency from '../../../../../../../components/formatted-currency';
import { DiscountBadge } from '../discount-badge/discount-badge';

const BillingPeriod = {
  Month: 'month',
  Year: 'year',
} as const;

export const PROMOTION = 'promotion' as const;
export const COUPON = 'coupon' as const;
export type DiscountVariant = typeof PROMOTION | typeof COUPON;

type PromotionalPriceProps = {
  originalPrice: number;
  discountedPrice: number;
  discountPercent: number;
  currencyCode: string;
  isAnnual?: boolean;
  variant?: DiscountVariant;
};

export const PromotionalPrice = memo(
  ({ originalPrice, discountedPrice, discountPercent, currencyCode, isAnnual = false, variant = PROMOTION }: PromotionalPriceProps) => {
    return (
      <FlexColumn className={styles['promotional-price']} gap={Gap.Space4}>
        <Text
          className={styles['discounted-price']}
          formattedMessageValues={{
            price: <FormattedCurrency currencyCode={currencyCode} value={discountedPrice} />,
          }}
          textType={TextType.H3}
          value={isAnnual ? messages.pricePerYear : messages.pricePerMonth}
        />
        <FlexRow className={styles['original-price-row']} gap={Gap.Space8}>
          <span className={styles.strikethrough}>
            <FormattedMessage
              {...messages.originalPriceWithPeriod}
              values={{
                price: <FormattedCurrency currencyCode={currencyCode} value={originalPrice} />,
                period: isAnnual ? BillingPeriod.Year : BillingPeriod.Month,
              }}
            />
          </span>
          <DiscountBadge discountPercent={discountPercent} variant={variant} />
        </FlexRow>
      </FlexColumn>
    );
  },
);
